import { ProgressBar as AriaProgressBar, ProgressBarProps as AriaProgressBarProps } from "react-aria-components";
import { composeTailwindRenderProps } from "../../utils";

/**
 * ProgressBar
 *
 * Linear progress indicator with optional labels.
 */
export interface ProgressBarProps extends AriaProgressBarProps {
  label?: string;
  rightLabel?: string;
  progressWidth?: number;
  hideLabels?: boolean;
}

export function ProgressBar({ label, rightLabel, progressWidth = 64, hideLabels = false, ...props }: ProgressBarProps) {
  return (
    <AriaProgressBar {...props} className={composeTailwindRenderProps(props.className, "flex flex-col gap-1")}>
      {({ percentage, valueText, isIndeterminate }) => (
        <>
          {!hideLabels && (
            <div className="flex items-center justify-between gap-2">
              <span className="text-sm text-text-primary">{label}</span>
              <span className="text-sm text-text-primary">{rightLabel || valueText}</span>
            </div>
          )}
          <div
            className={`relative h-2 w-${progressWidth} overflow-hidden rounded-full bg-background-muted outline-none`}
          >
            <div
              className={`absolute top-0 h-full rounded-full bg-action-default forced-colors:bg-[Highlight] ${isIndeterminate ? "left-full duration-1000 ease-out animate-in slide-out-to-right-full repeat-infinite [--tw-enter-translate-x:calc(-16rem-100%)]" : "left-0"}`}
              style={{ width: (isIndeterminate ? 40 : percentage) + "%" }}
            />
          </div>
        </>
      )}
    </AriaProgressBar>
  );
}
